@if(scannerEnabled()){
	<div class="scan-container">
		<div class="top-bar">
			<button (click)="back()" class="back-btn text-primary">
				<i class="fa-solid fa-arrow-left"></i> Retour
			</button>
		</div>

		@if(error()){
			<div class="error-container">
				<lgb-message [(error)]="error"></lgb-message>
			</div>
		}

		@if(devices().length > 1){
			<div class="cam-container">
				<select #cam (change)="selectDevice(cam.value ?? '')" class="select" name="cam">
					<option disabled>Choisissez votre caméra</option>
					@for(d of devices(); track d.deviceId; let i = $index){
						<option [value]="d.deviceId">{{ d.label }}</option>
					}
				</select>
			</div>
		}

		@if(!hasDevices()){
			<div class="no-device">
				<div>
					<div class="text-danger mb-4">
						<i class="fa-sharp fa-light fa-camera-slash"></i>
					</div>
					<p>Aucune caméra détectée.</p>
				</div>
			</div>
		}

		<zxing-scanner
			class="scanner"
			[enable]="true"
			[formats]="allowedFormats"
			[autostart]="true"
			[device]="selectedDevice()"
			(camerasFound)="onCamerasFound($event)"
			(camerasNotFound)="onCamerasNotFound()"
			(scanSuccess)="onScanSuccess($event)"
			(scanError)="onScanError($event)"
		></zxing-scanner>
	</div>
}